import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WikiItem\DeleteWikiItemController::deleteMethod
* @see app/Http/Controllers/WikiItem/DeleteWikiItemController.php
* @route '/api/wiki-items/delete/{wiki_item_id}'
*/
export const deleteMethod = (args: { wiki_item_id: string | number } | [wiki_item_id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/api/wiki-items/delete/{wiki_item_id}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\WikiItem\DeleteWikiItemController::deleteMethod
* @see app/Http/Controllers/WikiItem/DeleteWikiItemController.php
* @route '/api/wiki-items/delete/{wiki_item_id}'
*/
deleteMethod.url = (args: { wiki_item_id: string | number } | [wiki_item_id: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { wiki_item_id: args }
    }

    if (Array.isArray(args)) {
        args = {
            wiki_item_id: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        wiki_item_id: args.wiki_item_id,
    }

    return deleteMethod.definition.url
            .replace('{wiki_item_id}', parsedArgs.wiki_item_id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiItem\DeleteWikiItemController::deleteMethod
* @see app/Http/Controllers/WikiItem/DeleteWikiItemController.php
* @route '/api/wiki-items/delete/{wiki_item_id}'
*/
deleteMethod.delete = (args: { wiki_item_id: string | number } | [wiki_item_id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\WikiItem\DeleteWikiItemController::undo
* @see app/Http/Controllers/WikiItem/DeleteWikiItemController.php
* @route '/api/wiki-items/undo-delete/{wiki_item_id}'
*/
export const undo = (args: { wiki_item_id: string | number } | [wiki_item_id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

undo.definition = {
    methods: ["get","head"],
    url: '/api/wiki-items/undo-delete/{wiki_item_id}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\WikiItem\DeleteWikiItemController::undo
* @see app/Http/Controllers/WikiItem/DeleteWikiItemController.php
* @route '/api/wiki-items/undo-delete/{wiki_item_id}'
*/
undo.url = (args: { wiki_item_id: string | number } | [wiki_item_id: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { wiki_item_id: args }
    }

    if (Array.isArray(args)) {
        args = {
            wiki_item_id: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        wiki_item_id: args.wiki_item_id,
    }

    return undo.definition.url
            .replace('{wiki_item_id}', parsedArgs.wiki_item_id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiItem\DeleteWikiItemController::undo
* @see app/Http/Controllers/WikiItem/DeleteWikiItemController.php
* @route '/api/wiki-items/undo-delete/{wiki_item_id}'
*/
undo.get = (args: { wiki_item_id: string | number } | [wiki_item_id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WikiItem\DeleteWikiItemController::undo
* @see app/Http/Controllers/WikiItem/DeleteWikiItemController.php
* @route '/api/wiki-items/undo-delete/{wiki_item_id}'
*/
undo.head = (args: { wiki_item_id: string | number } | [wiki_item_id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: undo.url(args, options),
    method: 'head',
})

const DeleteWikiItemController = { deleteMethod, undo, delete: deleteMethod }

export default DeleteWikiItemController